/** Using Duck style Actions Architecture. See https://github.com/erikras/ducks-modular-redux */
import axios from 'axios';

const PREFIX = 'meta/'
//const SET_META = PREFIX + 'SET_META';
const SET_INTENTS = PREFIX + 'SET_INTENTS';
const SET_SETUP_TBOX = PREFIX + 'SET_SETUP_TBOX';
const SET_SETUP_DATA = PREFIX + 'SET_SETUP_DATA';
const SET_LOADER_FLAG = PREFIX + 'SET_LOADER_FLAG';
const SET_ACCOUNTS_TBOX = PREFIX + 'SET_ACCOUNTS_TBOX';
const SET_SETUP_ACCOUNTS = PREFIX + 'SET_SETUP_ACCOUNTS';
const SET_SETUP_RESTRICTIONS = PREFIX + 'SET_SETUP_RESTRICTIONS';
const SET_LIGHT_META_AND_OPS = PREFIX + 'SET_LIGHT_META_AND_OPS';
const SET_IMPORTS_AND_INTENTS = PREFIX + 'IMPORTS_AND_INTENTS';
const SET_SETUP_CONTACTS_TBOX_DATA = PREFIX + 'SET_SETUP_CONTACTS_TBOX_DATA';

const initialMetaState = {
  account: null,
  macro_types: [],
  setup: {
    id: null,
    mainAccountIds: null,
  },
  light_meta_and_ops: {},
  accounts_tbox: {},
  setupRestrictions: {},
  potential_imports: [],
  intents: [],
  imports: [],
  app_impls: {},
  app_intents: [],
  setup_accounts: {},
  setup_contacts_tbox: {},
  setup_tbox: {},
  loaded: false,
};
  
export default function metaReducer(state = initialMetaState, action = {}) {
  switch (action.type) {
    // case SET_META: {
    //   return {
    //     ...action.meta,
    //   };
    // }
    case SET_LOADER_FLAG: {
      return {
        ...state,
        loaded: action.loaded,
      };
    }
    case SET_SETUP_DATA: {
      return {
        ...state,
        account: action.account,
        setup: action.setup,
        macro_types: action.macro_types,
      };
    }
    case SET_SETUP_ACCOUNTS: {
      return {
        ...state,
        setup_accounts: action.setup_accounts,
      };
    }
    case SET_SETUP_CONTACTS_TBOX_DATA: {
      return {
        ...state,
        setup_contacts_tbox: action.setup_contacts_tbox,
      };
    }
    case SET_LIGHT_META_AND_OPS: {
      return {
        ...state,
        light_meta_and_ops: action.light_meta_and_ops,
      };
    }
    case SET_ACCOUNTS_TBOX: {
      return {
        ...state,
        accounts_tbox: action.setup_accounts_tbox,
      }
    }
    case SET_SETUP_TBOX: {
      return {
        ...state,
        setup_tbox: action.setup_tbox,
      }
    }
    case SET_SETUP_RESTRICTIONS: {
      return {
        ...state,
        setupRestrictions: action.setupRestrictions,
      }
    }
    case SET_INTENTS: {
      return {
        ...state,
        intents: action.intents,
      }
    }
    case SET_IMPORTS_AND_INTENTS: {
      return {
        ...state,
        imports: action.imports,
        app_impls: action.app_impls,
        app_intents: action.app_intents,
        potential_imports: action.potential_imports,
      }
    }
    default: {
      return state;
    }
  }
};

//setLoadedFlag
export const setLoadedFlag = ( loaded ) => {
  return {
    type: SET_LOADER_FLAG,
    loaded,
  };
};

// export const setMeta = (meta) => {
//   return {
//     type: SET_META,
//     meta: meta,
//   };
// };

//setLightMetaQueryWithOps
export const setLightMetaQueryWithOps = ({ light_meta_and_ops }) => {
  return {
    type: SET_LIGHT_META_AND_OPS,
    light_meta_and_ops: { ...light_meta_and_ops },
  };
};

const collectLightMetaAndOps = (res) => {
  const { setup_rbox_light, predicates_ops } = res._meta_query;
  return {
    light_meta_and_ops: {
      setup_rbox_light: { ...setup_rbox_light },
      predicates_ops: { ...predicates_ops },
    }
  };
};

export const updateLightMetaAndOps = () => {
  return (dispatch) => {
    return axios
      .get(`/meta_query?meta_query=["setup_rbox_light", "predicates_ops"]`)
      .then(({ data }) => {
        const light_meta_and_ops = collectLightMetaAndOps(data);

        return dispatch(setLightMetaQueryWithOps(light_meta_and_ops));
      })
      .catch((error) => {
        console.log(error);
      });
  };
};

//setSetupContactsTboxData
export const setSetupContactsTboxData = ({ setup_contacts_tbox }) => {
  return {
    type: SET_SETUP_CONTACTS_TBOX_DATA,
    setup_contacts_tbox: { ...setup_contacts_tbox },
  };
};

//setSetupData
export const setSetupData = (account, setup, macro_types) => {
  return {
    type: SET_SETUP_DATA,
    setup: { ...setup },
    account: { ...account },
    macro_types: [ ...macro_types ],
  };
};

const collectSetupData = (res) => {
  const { account, setup, macro_types } = res._meta_query;
  return {
    setup,
    account,
    macro_types,
  };
};

export const updateSetupData = () => {
  return (dispatch) => {
    return axios
      .get(`/meta_query?meta_query=["account", "setup", "macro_types"]`)
      .then(({ data }) => {
        const setupData = collectSetupData(data);
        const { account, setup, macro_types } = setupData;

        return dispatch(setSetupData(account, setup, macro_types));
      })
      .catch((error) => {
        console.log(error);
      });
  };
};


//setSetupRestrictions
export const setSetupRestrictions = ({ setupRestrictions }) => {
  return {
    type: SET_SETUP_RESTRICTIONS,
    setupRestrictions: { ...setupRestrictions },
  };
};

const collectSetupRestrictions = (res) => {
  const setupRestrictions = res._meta_query.setup_restrictions || {};
  return {
    setupRestrictions: { ...setupRestrictions },
  };
};

export const updateSetupRestrictions = () => {
  return (dispatch) => {
    return axios
      .get(`/meta_query?meta_query=["setup_restrictions"]`)
      .then(({ data }) => {
        const setupRestrictions = collectSetupRestrictions(data);

        return dispatch(setSetupRestrictions(setupRestrictions));
      })
      .catch((error) => {
        console.log(error);
      });
  };
};


//Intents
export const setSetupIntents = ({ intents }) => {
  return {
    type: SET_INTENTS,
    intents: [ ...intents ],
  };
};

const collectIntents = (res) => {
  const intents = res._meta_query.intents || [];
  return {
    intents,
  };
};

export const updateMetaIntents = () => {
  return (dispatch) => {
    return axios
      .get(`/meta_query?meta_query=["intents"]`)
      .then(({ data }) => {
        const intents = collectIntents(data);

        return dispatch(setSetupIntents(intents));
      })
      .catch((error) => {
        console.log(error);
      });
  };
};


//Imports and appIntents (app_intents, imports, potential_imports)
export const setSetupImportsAndIntents = ({ app_intents, app_impls, imports, potential_imports }) => {
  return {
    type: SET_IMPORTS_AND_INTENTS,
    imports: [ ...imports ],
    app_impls: { ...app_impls},
    app_intents: [ ...app_intents ],
    potential_imports: [ ...potential_imports ],
  };
};

const collectImportsAndIntents = (res) => {
  const imports = res._meta_query.imports || [];
  const app_impls = res._meta_query.app_impls || {};
  const app_intents = res._meta_query.app_intents || [];
  const potential_imports = res._meta_query.potential_imports || [];
  return {
    imports,
    app_impls,
    app_intents,
    potential_imports,
  };
};

export const updateMetaImportsAndIntents = () => {
  return (dispatch) => {
    return axios
      .get(`/meta_query?meta_query=["app_intents", "imports", "potential_imports", "app_impls"]`)
      .then(({ data }) => {
        const importsAndIntents = collectImportsAndIntents(data);

        return dispatch(setSetupImportsAndIntents(importsAndIntents));
      })
      .catch((error) => {
        console.log(error);
      });
  };
};

//setup_tbox
export const setSetupTbox = ({ setup_tbox }) => {
  return {
    type: SET_SETUP_TBOX,
    setup_tbox: { ...setup_tbox },
  };
};

const collectSetupTbox = (res) => {
  const setup_tbox = res._meta_query.setup_tbox || {};
  return {
    setup_tbox: { ...setup_tbox },
  };
};

export const updateSetupTbox = () => {
  return (dispatch) => {
    return axios
      .get(`/meta_query?meta_query=["setup_tbox"]`)
      .then(({ data }) => {
        const setup_tbox = collectSetupTbox(data);

        return dispatch(setSetupTbox(setup_tbox));
      })
      .catch((error) => {
        console.log(error);
      });
  };
};


//setup_accounts
export const setSetupAccounts = ({ setup_accounts }) => {
  return {
    type: SET_SETUP_ACCOUNTS,
    setup_accounts: { ...setup_accounts },
  };
};

const collectSetupAccounts = (res) => {
  const setup_accounts = res._meta_query.setup_accounts || {};
  return {
    setup_accounts: {...setup_accounts},
  };
};

export const updateSetupAccounts = () => {
  return (dispatch) => {
    return axios
      .get(`/meta_query?meta_query=["setup_accounts"]`)
      .then(({ data }) => {
        const setup_accounts = collectSetupAccounts(data);

        return dispatch(setSetupAccounts(setup_accounts));
      })
      .catch((error) => {
        console.log(error);
      });
  };
};

//setup_accounts_tbox
export const setAccountsTbox = ({ setup_accounts_tbox }) => {
  return {
    type: SET_ACCOUNTS_TBOX,
    setup_accounts_tbox: { ...setup_accounts_tbox },
  };
};

const collectAccountsTbox = (res) => {
  const setup_accounts_tbox = res._meta_query.setup_accounts_tbox || {};
  return {
    setup_accounts_tbox: {
      nodes: {...setup_accounts_tbox.nodes} || {},
      implemented_cids: [...setup_accounts_tbox.implemented_cids] || [],
      interface_id: setup_accounts_tbox.interface_id || '',
    }
  };
};

export const updateAccountsTbox = () => {
  return (dispatch) => {
    return axios
      .get(`/meta_query?meta_query=["setup_accounts_tbox"]`)
      .then(({ data }) => {
        const setup_accounts_tbox = collectAccountsTbox(data);

        return dispatch(setAccountsTbox(setup_accounts_tbox));
      })
      .catch((error) => {
        console.log(error);
      });
  };
};

// export const collectMeta = (res, setupData) => {
//   const setupDataObject = res._meta_query.setup_accounts_tbox || [];
//   const setupRestrictions = res._meta_query.setup_restrictions || [];
//   const setup_accounts = res._meta_query.setup_accounts || {};
//   const setup_tbox = res._meta_query.setup_tbox || {};
//   const intents = res._meta_query.intents || [];
//   const app_intents = res._meta_query.app_intents || [];
//   const imports = res._meta_query.imports || [];
//   const potential_imports = res._meta_query.potential_imports || [];
  

//   setupData.intents = intents || [];
//   setupData.imports = imports || [];
//   setupData.app_intents = app_intents || [];
//   setupData.potential_imports = potential_imports || [];
//   setupData.setup.accounts_tbox = setupDataObject.nodes || {};
//   setupData.setup.setup_accounts = setup_accounts || {};
//   setupData.setup.setup_tbox = setup_tbox || {};
//   setupData.setup.interface_id = setupDataObject.interface_id;
//   setupData.setup.mainAccountIds = res._meta_query.setup_accounts_tbox.implemented_cids || {};

//   return {
//     setupRestrictions,
//     setup: setupData.setup,
//     account: setupData.account,
//     intents: setupData.intents,
//     imports: setupData.imports,
//     app_intents: setupData.app_intents,
//     potential_imports: setupData.potential_imports,
//   };
// };
